import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Modals from 'root/modals';
import Util from 'root/module/util';
import Form from 'root/module/form';
import View from 'view/base';

export default View.extend({
    logo_data: {},
    favicon_data: {},

    events: {
        'click .logo-placeholder'          : 'onUploadLogo',
        'click .logo-preview img'          : 'onUploadLogo',
        'click .favicon-placeholder'       : 'onUploadFavicon',
        'click .favicon-preview img'       : 'onUploadFavicon',
        'click .logo-preview .delete'      : 'onDeleteLogo',
        'click .favicon-preview .delete'   : 'onDeleteFavicon',
        'click .powered-by-toggle'         : 'onTogglePoweredBy',
        'input input[name="theme_colour"]' : 'onThemeColourChange',
        'submit form'                      : 'onSubmit'
    },

    dom_handlers: {
        onUploadLogo: function(e) {
            Util.uploadImages(1, 10, function(response) {
                if (!response.length) {
                    UI.error('Please select an image file.');
                } else if (response[0].error) {
                    UI.error(response[0].error);
                } else {
                    this.logo_data = response[0];
                    this.renderLogoUploader();

                    Cache.app.request({
                        action: 'portal/uploadLogo',
                        data: _.extend({
                            portal_id: this.model.id
                        }, this.logo_data),
                        context: this,
                        success: function(response) {
                            this.model.set(response);
                            UI.success('Logo uploaded');
                        }
                    });
                }
            }.bind(this));
        },

        onUploadFavicon: function(e) {
            Util.uploadImages(1, 10, function(response) {
                if (response[0].error) {
                    UI.error(response[0].error);
                } else {
                    this.favicon_data = response[0];
                    this.renderFaviconUploader();

                    Cache.app.request({
                        action: 'portal/uploadFavicon',
                        data: _.extend({
                            portal_id: this.model.id
                        }, this.favicon_data),
                        context: this,
                        success: function(response) {
                            this.model.set(response);
                            UI.success('Favicon uploaded');
                        }
                    });
                }
            }.bind(this));
        },

        onDeleteLogo: function(e) {
            this.logo_data = {content: 'delete'};
            this.renderLogoUploader();

            Cache.app.request({
                action: 'portal/deleteLogo',
                data: {
                    portal_id: this.model.id
                },
                context: this,
                success: function() {
                    this.model.set('logo', '');
                    UI.success('Logo deleted');
                }
            });
        },

        onDeleteFavicon: function(e) {
            this.favicon_data = {content: 'delete'};
            this.renderFaviconUploader();

            Cache.app.request({
                action: 'portal/deleteFavicon',
                data: {
                    portal_id: this.model.id
                },
                context: this,
                success: function() {
                    this.model.set('favicon', '');
                    UI.success('Favicon deleted');
                }
            });
        },

        onTogglePoweredBy: function(e) {
            if (!Cache.account.hasFeature('powered_by')) {
                Modals.unlockFeature();
                return;
            }

            if (this.$el.find('.powered-by-toggle').hasClass('switch-on')) {
                this.$el.find('.powered-by-toggle').addClass('switch-off').removeClass('switch-on');
            } else {
                this.$el.find('.powered-by-toggle').addClass('switch-on').removeClass('switch-off');
            }

            this.$el.find('form button:submit').click();
        },

        onThemeColourChange: function(e) {
            var theme_colour = $(e.currentTarget).val();

            if (Util.isValidHex(theme_colour)) {
                this.$el.find('form button:submit').click();
            }
        },

        onSubmit: function(e) {
            var form_data = Form.getData(this.$el.find('form'));

            this.$el.find('button:submit').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'portal/update',
                data: {
                    portal_id    : this.model.id,
                    theme_colour : form_data.theme_colour,
                    powered_by   : this.$el.find('.powered-by-toggle').hasClass('switch-on')
                },
                context: this,
                success: function(response) {
                    this.model.set(response);
                    UI.success('Branding settings updated');
                },
                complete: function() {
                    this.$el.find('button:submit').removeClass('loading').prop('disabled', false);
                }
            });
        }
    },

    renderLogoUploader: function() {
        var html = '';

        if (this.logo_data.content === 'delete') {
            html = '<div class="logo-placeholder"></div>';
        } else if (this.logo_data.content || this.model.get('logo')) {
            html = '<div class="logo-preview">' +
                        '<img src="' + (this.logo_data.content || this.model.get('logo')) + '">' +
                        '<div class="delete"><i class="fas fa-times"></i></div>' +
                    '</div>';
        } else {
            html = '<div class="logo-placeholder"></div>';
        }

        this.$el.find('.logo-uploader').html(html);
    },

    renderFaviconUploader: function() {
        var html = '';

        if (this.favicon_data.content === 'delete') {
            html = '<div class="favicon-placeholder"></div>';
        } else if (this.favicon_data.content || this.model.get('favicon')) {
            html = '<div class="favicon-preview">' +
                        '<img src="' + (this.favicon_data.content || this.model.get('favicon')) + '">' +
                        '<div class="delete"><i class="fas fa-times"></i></div>' +
                    '</div>';
        } else {
            html = '<div class="favicon-placeholder"></div>';
        }

        this.$el.find('.favicon-uploader').html(html);
    },

    render: function() {
        var content = '';

        content +=
        '<form class="form-fluid">' +
            '<div class="box box-nopadding">' +
                '<div class="padding-32">' +
                    '<h3>Logo</h3>' +
                    '<div class="grid-4-8 grid-none-mobile">' +
                        '<div>' +
                            '<div class="text-info text-medium">Recommended size: 150 x 28<br>(png, jpg or svg)</div>' +
                        '</div>' +
                        '<div class="logo-uploader"></div>' +
                    '</div>' +
                '</div>' +

                '<hr class="xsmall">' +

                '<div class="padding-32">' +
                    '<h3>Favicon</h3>' +
                    '<div class="grid-4-8 grid-none-mobile">' +
                        '<div>' +
                            '<div class="text-info text-medium">Recommended size: 64 x 64<br>(png only)</div>' +
                        '</div>' +
                        '<div class="favicon-uploader"></div>' +
                    '</div>' +
                '</div>' +

                '<hr class="xsmall">' +

                '<div class="grid-4-8 grid-none-mobile padding-32">' +
                    '<div>' +
                        '<h3 class="margin-top-8">Theme color</h3>' +
                    '</div>' +
                    '<div>' +
                        '<input type="text" name="theme_colour" class="solid colour medium" placeholder="#6042EC" maxlength="7" spellcheck="false">' +
                    '</div>' +
                '</div>' +

                '<hr class="xsmall">' +

                '<div class="padding-32 flex-between-top">' +
                    '<div>' +
                        '<h3>Powered by</h3>' +
                        '<div class="text-info text-medium">Hide "Powered by Userback" banner</div>' +
                    '</div>' +
                    '<div>' +
                        (Cache.account.hasFeature('powered_by') ? '' :
                        '<span class="toggle-lock"><i class="fas fa-lock-alt"></i></span>') +
                        '<button type="button" class="powered-by-toggle small ' + (this.model.get('powered_by') || !Cache.account.hasFeature('powered_by') ? 'switch-on' : 'switch-off') + '"></button>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            '<button tyle="submit hidden"></button>' +
        '</form>';

        this.$el.html(content);

        this.renderLogoUploader();
        this.renderFaviconUploader();

        Form.setData(this.$el.find('form'), this.model.attributes);

        if (!Cache.account.hasFeature('powered_by')) {
            this.$el.find('.powered-by-toggle').addClass('disabled');
        }

        return this;
    }
});